import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PhotoTypeEnum } from "../../types/commonTypes";
import { CommunicationType, FileItemType } from "../../types/communication/communicationDataType"
import FileListCmp from "../file/FileListCmp";
import { Vspace } from "../styled/Separators.style";
import CameraUploadCmp from "./CameraUploadCmp";

interface CameraUploadListCmpProps {
    fileType: PhotoTypeEnum
    additionalBeInfo: any
    customContainerClass?: string
    photoClickHandler?: any
    onCloseHandler: any
    rightItem?: any
    leftItem?: any
    overlaySuggestItem?: any
    mainLabelItem?: any
    showCamera: boolean
    setShowCamera: any
    needPhotoConfirmBeforeUploading?: boolean

    files: FileItemType[]
    setFiles: any,
    arrayDbPropSync?: string
    textLabel?: string
    hideCameraAddButton?: boolean
    titleImageDetail?: string
    addButtonInLastPlace?: boolean
    onTotFotoIsRiched?: any
    totPhotosForStepDone?: number
}

/* istanbul ignore next */
const CameraUploadListCmp = (props: CameraUploadListCmpProps) => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { files, setFiles, arrayDbPropSync, textLabel,
        customContainerClass, leftItem, rightItem, mainLabelItem, overlaySuggestItem,
        onCloseHandler, showCamera, needPhotoConfirmBeforeUploading, setShowCamera,
        photoClickHandler, hideCameraAddButton, titleImageDetail, addButtonInLastPlace,
        fileType, additionalBeInfo, onTotFotoIsRiched, totPhotosForStepDone
    } = props

    const updateDbCommunicationFileList = (newFileList: FileItemType[]) => {
        if (arrayDbPropSync) {
            const updComm: any = new CommunicationType(communication)
            updComm[arrayDbPropSync] = newFileList
            dispatch(saveCommunicationAct({
                data: updComm
            })
            )

            if (totPhotosForStepDone && newFileList?.length >= totPhotosForStepDone) {
                onTotFotoIsRiched?.()
            }

        }
    }

    const onFileUpsertHandler = (_file?: FileItemType) => {
        if (!_file) {
            return _file
        }
        setFiles((currentFiles: FileItemType[]) => {
            let fileFound = false
            const newFiles = currentFiles.map((file: FileItemType) => {
                if ((_file._id === file._id) ||
                    (_file.name === file.name && !file._id)
                ) {
                    fileFound = true;
                    return { ..._file, additionalBeInfo: { ...(additionalBeInfo || {}) } }
                } else {
                    return file
                }
            }) || []
            let newFilesArray = []
            if (fileFound) {
                newFilesArray = [...newFiles]
            } else {
                newFilesArray = [...newFiles, _file]
            }

            // sync db array prop, if present
            if (_file._id) {
                updateDbCommunicationFileList(newFilesArray)
            }
            return newFilesArray
        })
    }

    const onFileRemovedHandler = (_file?: FileItemType) => {
        if (!_file) {
            return _file
        }
        setFiles((currentFiles: FileItemType[]) => {
            const newFilesArray = currentFiles.filter((file: FileItemType) => file._id !== _file._id)
            updateDbCommunicationFileList(newFilesArray)
            return newFilesArray;
        })
    }

    const isInFileList = files?.length > 0

    const fileUploadCmp = <CameraUploadCmp
        fileType={fileType}
        additionalBeInfo={additionalBeInfo}
        customContainerClass={customContainerClass}
        isInFileList={isInFileList}
        photoClickHandler={photoClickHandler}
        onCloseHandler={onCloseHandler}
        rightItem={rightItem}
        leftItem={leftItem}
        overlaySuggestItem={overlaySuggestItem}
        mainLabelItem={mainLabelItem}
        showCamera={showCamera}
        setShowCamera={setShowCamera}
        needPhotoConfirmBeforeUploading={needPhotoConfirmBeforeUploading}

        files={files}
        onFileAdded={onFileUpsertHandler}
        onFileRemoved={onFileRemovedHandler}
        className={files.length === 0 ? "foto-list-camera-upload" : "foto-list-camera-upload wrapped"}
        textLabel={textLabel}
        token={communication.token}
        hideCameraAddButton={hideCameraAddButton}
    />

    return (
        <>
            {files.length === 0 ? fileUploadCmp : <></>}
            <Vspace qty={2}></Vspace>

            <FileListCmp
                children={files.length ? fileUploadCmp : <></>}
                files={files}
                onFileRemoved={onFileRemovedHandler}
                className={"foto-list-camera-upload"}
                hasResizer={true}
                previewCustomClass={'camera-photo-preview'}
                isCameraFileImage={true}
                titleImageDetail={titleImageDetail}
                addButtonInLastPlace={addButtonInLastPlace}
                deleteLabelPresent={true}
            />
            <Vspace qty={2}></Vspace>
        </>
    )
}

export default CameraUploadListCmp